import OrderEntryForm from './OrderEntryForm';

function OrderViewForm() {
  return <OrderEntryForm readOnly={true} />;
}

export default OrderViewForm;
